import React from "react";
import FormShimmer from "../shimmer/FormShimmer ";

const AddEditLoader = ({ title = "", rows = 4, cols = 2 }) => {
  return (
    <div className="page-content add_plan">
      <h4 className="page_title mb-3">{title}</h4>

      <div className="common_card">
        <FormShimmer rows={rows} cols={cols} />
      </div>
    </div>
  );
};

export default AddEditLoader;
